import { Component, OnInit } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { FeatureService } from 'app/features/feature.service';
import * as moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../environments/environment';
import { Configuration } from '../core/config';
import { ConfigService } from '../core/config.service';
import { Domain } from '../core/domain';
import { SystemSettings } from '../core/system-configuration/system-settings';

@Component({
  selector: 'hb-about-dlg',
  templateUrl: './about-dialog.component.html',
  styleUrls: ['./about-dialog.component.scss'],
})
export class AboutDialogComponent implements OnInit {
  public version: string = environment.version;
  public domain: string = '';
  public aboutItems: any[] = new Array<any>();
  public currentYear: string;

  public constructor(public bsModalRef: BsModalRef, private configService: ConfigService, private systemSettings: SystemSettings,private featureService: FeatureService, private i18NextPipe: I18NextPipe,) { }

  public ngOnInit(): void {
    const configuration: Configuration = this.configService.getConfiguration();

    this.aboutItems = configuration.aboutItems;
    this.currentYear = moment(new Date()).format('YYYY');
    this.domain = this.systemSettings.domain === Domain.Marine ? this.systemSettings.domain : '';
  }

  public close(): void {
    this.bsModalRef.hide();
  }
}
